import type { User } from "src/types/user";

export const useMockedUser = (): User => {
  // To get the user from the authContext, you can use
  // `const { user } = useAuth();`
  return {
    id: "1",
    avatar: "/assets/1.png",
    name: "Zachary, Relight Admin",
    email: "admin@relightexteriorlighting.com",
  };
};
